import { useLoggedInUser } from "components/LoggedInUserProvider";
import React from "react";

import TrainerStallApplicationPage from "./Trainer";
import RacingOfficialStallApplicationPage from "./RacingOfficial";

const StallApplicationPage = () => {
  const { currentUser } = useLoggedInUser();

  if (currentUser.isTrainer || currentUser.isAssistantTrainer) {
    return <TrainerStallApplicationPage />;
  }

  if (currentUser.isRacingOfficial || currentUser.isAdmin) {
    return <RacingOfficialStallApplicationPage />;
  }

  return <></>;
};

export default StallApplicationPage;
